import {
  Button, Checkbox,
  Modal,
  ModalBody,
  ModalHeader,
  ModalProps, Select,
  Stack,
  Textarea,
  TextInput
} from "@mantine/core";
import {useForm} from "@mantine/form";
import {DatePickerInput} from "@mantine/dates";
import PlannedFailureAPI from "../../../api/planned/failure/PlannedFailureAPI";
import {showNotification} from "@mantine/notifications";
import PlannedFailure from "../../../api/planned/failure/PlannedFailure";
import {useEffect, useState} from "react";

const format = (dateString: string) => {
    if (dateString === null || dateString === undefined || dateString === "") {
        return undefined;
    }

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns zero-based month
    const day = ('0' + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
}

type UpdatePlannedFailureModalProps = Omit<ModalProps, "children" | "opened"> & { plannedFailure: PlannedFailure | undefined };

export default function UpdatePlannedFailureModal(props: UpdatePlannedFailureModalProps) {
    const [_isDone, _setIsDone] = useState(false);

    const form = useForm({
        mode: 'uncontrolled',
        initialValues: {
          location: '',
          date: new Date(),
          description: '',
        }
    });

    const onSubmit = (data: any) => {
        if (props.plannedFailure === undefined) {
            throw new Error("Planned failure is undefined, could not resolve ID.");
        }

        PlannedFailureAPI.update(props.plannedFailure.id, {...data, isDone: _isDone, date: format(data.date)})
            .then(() => { showNotification({ title: 'Utworzono!', message: "Awaria została utworzona" }) })
            .then(props.onClose);
    }

    useEffect(() => {
        if (!props.plannedFailure) {
          return;
        }

        form.setValues({
            date: props.plannedFailure ? new Date(props.plannedFailure.date) : undefined,
            location: props.plannedFailure.location,
            description: props.plannedFailure.description,
        });

        _setIsDone(props.plannedFailure.isDone ?? false);
        // eslint-disable-next-line
    }, [props.plannedFailure]);

    return (
        <Modal opened={props.plannedFailure !== undefined} {...props}>
            <ModalHeader>
                Zmień planowaną awarie
            </ModalHeader>

            <ModalBody>
                <form onSubmit={form.onSubmit(onSubmit)}>
                    <Stack gap="sm" style={{ width: '100%' }}>
                        <DatePickerInput
                            required
                            label="Data"
                            valueFormat="DD-MM-YYYY"
                            key={form.key('date')}
                            { ...form.getInputProps('date') }
                        />

                        <TextInput
                            required
                            label="Miejsce"
                            placeholder="Miejsce"
                            key={form.key('location')}
                            { ...form.getInputProps('location') }
                        />

                        <Textarea
                            required
                            label="Opis"
                            rows={10}
                            placeholder="Opis"
                            key={form.key('description')}
                            description="Inne informacje np. metoda zabezpieczenia"
                            { ...form.getInputProps('description') }
                        />

                      <Checkbox
                        label="Czy awaria została zakończona?"
                        onChange={(event) => { _setIsDone(event.currentTarget.checked); }}
                        checked={_isDone}
                      />

                        <Button
                            fullWidth
                            type="submit"
                            children="Zapisz"
                        />
                    </Stack>
                </form>
            </ModalBody>
        </Modal>
    );
}